import React from 'react';

const PortfolioPostResults = () => {
    return (
        <section>
            <div className="stg-row stg-bottom-gap">
                <div className="stg-col-6" data-appear="fade-up" data-unload="fade-left">
                    <h2>Results & Impact</h2>
                </div>
            </div>
            <div className="stg-row" data-appear="fade-up" data-delay="100" data-unload="fade-right">
                <div className="stg-col-9 stg-offset-3 stg-tp-col-10 stg-tp-offset-2">
                    <p className="infocolors-large-text">Following the brand identity launch, Curology saw a significant increase in brand awareness and customer engagement. Their social media following skyrocketed, and sales metrics exceeded expectations. The new brand resonated deeply with customers, creating a loyal community empowered to take control of their skin.</p>
                </div>
            </div>
        </section>
    );
};

export default PortfolioPostResults;
